import Tabs from './Tabs';
import Expander from './Expander';

export default function initRelink()
{
    let tabs = new Tabs('.js-relink-tab');
    tabs.init();

    tabs.list().forEach(control => {
        if (tabs.isActive(control)) {
            let tab = tabs.getTabByControl(control);
            linkArrangement(tab);
            let relinkExpander = new Expander(tab);
        }

        control.addEventListener('tabs.after.switch', evt => {
            let e = evt as CustomEvent;
            linkArrangement(e.detail.target);
            let relinkExpander = new Expander(e.detail.target);
        });
    });
}

function linkArrangement(tab: Element)
{
    let maxWidth = 0;

    tab.querySelectorAll('.relink__content').forEach(node => {
        let block = node as HTMLElement;
        let links = node.querySelectorAll('.relink__link');

        links.forEach(element => {
            let link = element as HTMLElement;
            if (link.offsetWidth > maxWidth) {
                maxWidth = link.offsetWidth;
            }
        });
        // получаем оставшуюся ширину блока-родителя
        let reminder = block.clientWidth % maxWidth;
        // считаем количество колонок
        let columnsCount = Math.floor(block.clientWidth/maxWidth);
        // считаем добавочную ширину для каждой колонки
        let columnAddition = Math.floor(reminder/columnsCount);

        maxWidth += columnAddition;

        links.forEach(element => {
            let link = element as HTMLElement;
            link.style.width = maxWidth + "px";
        });

        //console.log(block.offsetHeight);
        if (block.offsetHeight > 180) {
            block.classList.add('relink__content_bound');
        }
    });
}